import React, { Component, Fragment } from "react";
import { Form, FormGroup, Label, Input, Col, Row, TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import BlockUi from 'react-block-ui';
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import Messages from '../../notifications/Messages'
import Select from 'react-select';
import Errors from '../../notifications/Errors'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import * as khachhangAction from './actions'
import * as khachhangConstant from './constants'
import { storedb } from '../client/storedb'
import * as common from '../../lib/common'
import CheckboxTreeList from "../controls/_CheckboxTreeList";
import * as settingAction from '../Setting/actions'
import { BtnPermissions, BtnType } from '../../lib/BtnPermissions';
import { ButtonExt } from "../controls/ButtonExt"
import AppConfig from "../../config/app";
import DiemTichLuyEdit from "./_DiemTichLuyEdit";
const listLich = [
  { value: '0', label: 'Chủ nhật' },
  { value: '1', label: 'Thứ 2' },
  { value: '2', label: 'Thứ 3' },
  { value: '3', label: 'Thứ 4' },
  { value: '4', label: 'Thứ 5' },
  { value: '5', label: 'Thứ 6' },
  { value: '6', label: 'Thứ 7' }
];

class KhachhangEdit extends Component {
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      item: {
        StoreId: dbContext.getStoreId(),
        TrangThai: AppConfig.KHACHHANG_DANGHOATDONG,
        Rank: "",
        SyncUserName: ''
      },
      modalEditDiem: false,
      listDvhc: [],
      formError: {},
      formValid: false,
      stores_id: dbContext.getStoreId(),
      selectedOptionLich: null,
      selectedOptionTinhThanh: null,
      selectedOption: null,
      treeQuanLy: [],
      checkedQuanLy: [],
      multipleValueQuanLy: [],
      idKhEdit: 0,
      activeTab: 1,
      numberOfUser: 0
    };
  }
  getParam = (name) => {
    const queryParamsString = this.props.location.search.substring(1),
      searchParams = new URLSearchParams(queryParamsString);
    return searchParams.get(name);
  }
  handleTabChange = (activeTab) => {
    this.setState({ activeTab: activeTab })
  }
  handleControlChange = (e) => {
    this.props.khachhangUploadError("");
    let { item } = this.state
    switch (e.target.name) {
      case "SyncUserName":
        item[e.target.name] = common.removeUnicode(e.target.value)
        break
      default:
        item[e.target.name] = e.target.value
        break
    }
    this.setState({ item })
  }
  handleSelectChange = (name, selectedOption) => {
    let { item } = this.state;
    this.props.khachhangUploadError("");
    if (selectedOption.name) {
      switch (selectedOption.name) {
        case "TinhThanh":
          this.setState({ selectedOptionTinhThanh: name })
          item.RegionId = name.value
          item.RegionName = name.label
          item.RegionCode = name.ma
          break;
        case "LichChamSoc":
          this.setState({ selectedOptionLich: name })
          let arrName = name.map((item) => { return item.label }).join(',');
          let arrValue = name.map((item) => { return item.value }).join(',');
          item.TuyenChamSoc = arrValue;
          item.TuyenChamSocText = arrName;
          break;
        default:
          break;
      }
    } else {
      switch (name) {
        case "TrangThai":
          item.TrangThai = selectedOption.target.value
          break;
        case "LoaiKhachHang":
          item.LoaiKhachHangId = selectedOption.target.value
          item.TenLoaiKhachHang = selectedOption.target[selectedOption.target.selectedIndex].text
          break;
        case "Rank":
          item.Rank = selectedOption.target.value
          item.RankName = selectedOption.target[selectedOption.target.selectedIndex].text
          break;
        default:
          break;
      }
    }
    this.setState({ item })
  }
  handleDateChange = (name, obj) => {
    let { item } = this.state;
    switch (name) {
      case "NgaySinh":
        item.NgaySinh = obj.format();
        break;
      case "NgayKyHd":
        item.NgayKyHd = obj.format();
        break;
      default:
        break;
    }
    this.setState({ item })
  }
  onHandleRemoveQuanLy = () => {
    this.setState({ multipleValueQuanLy: [] })
  }
  onHandleChoiceQuanLy = (nodesChecked) => {
    var multipleValue = [];
    nodesChecked.forEach(function (item) {
      multipleValue.push(item.value);
    });
    let { item } = this.state;
    if (nodesChecked[0].data) {
      item.MaQuanLy = nodesChecked[0].data.SubName
      item.TenQuanLy = nodesChecked[0].data.Name
      item.IdQuanLy = nodesChecked[0].data.Id
    }
    this.setState({ multipleValueQuanLy: multipleValue, item })
  }
  handleCheckIntergrate = ({ target }) => {
    let { item } = this.state;
    item.IsIntergrate = target.checked
    this.setState({ IsIntergrate: target.checked })
  }
  convertToMoment = (date) => {
    if (typeof date == 'string') {
      return moment(date);
    }
    return date;
  }
  Cancel = () => {
    this.featchDetail();
  }
  featchCmb = () => {
    const { cmbListRequest } = this.props;
    let requestData = {
      stores_id: this.state.stores_id,
      page: 1,
      per_page: 200,
    };
    return cmbListRequest(requestData);
  }
  featchConfig = () => {
    const { settingGetConfigRequest } = this.props;
    let requestData = {
      keySetting: AppConfig.SETTINGKEYS.LimitNumberOfUser
    };
    return settingGetConfigRequest(requestData, (res) => {
      if (res.code == 200) {
        this.setState({ numberOfUser: res.data })
      }
    });
  }
  featchDetail = () => {
    const { khachhangDetailRequest } = this.props
    let khachHangId = this.getParam("kid");
    var requestData = {
      khach_hang_id: khachHangId || 0,
      store_id: this.state.stores_id
    }
    return khachhangDetailRequest(requestData);
  }
  EditDiemTichLuy = (isChanged) => {
    this.setState({ modalEditDiem: !this.state.modalEditDiem })
    if (isChanged) {
      this.featchDetail()
    }
  }
  Updatekhachhang = () => {
    let formError = {};
    let { item } = this.state
    let formValid = true;
    if (!item.Ma || item.Ma == "") {
      formError.Ten = 'Bạn chưa nhập mã khách hàng';
    }
    if (!item.Ten || item.Ten == "") {
      formError.Ten = 'Bạn chưa nhập tên khách hàng';
    }
    if (!item.DiaChi || item.DiaChi == "") {
      formError.DiaChi = 'Bạn chưa nhập địa chỉ';
    }
    if (!item.NguoiDaiDien || item.NguoiDaiDien == "") {
      formError.NguoiDaiDien = 'Bạn chưa nhập người đại diện';
    }
    if (!item.DienThoai || item.DienThoai == "") {
      formError.DienThoai = 'Bạn chưa nhập số di động';
    }
    if (!item.RegionId) {
      formError.RegionId = 'Bạn chưa nhập tỉnh thành';
    }
    if (!item.MaQuanLy) {
      formError.IdQuanLy = 'Bạn chưa nhập người quản lý';
    }
    if (item.TrangThai == -1) {
      formError.TrangThai = 'Bạn chưa nhập trạng thái';
    }
    if (!item.NgaySinh || item.NgaySinh == null) {
      formError.NgaySinh = 'Bạn chưa nhập ngày sinh';
    }
    if (item.IsIntergrate && (item.SyncUserId || 0) == 0) {
      if (!item.SyncUserName || !item.SyncPassword
        || item.SyncUserName == "" || item.SyncPassword == "") {
        formError.SyncUserName = 'Bạn cần nhập tên đăng nhập và mật khẩu';
        formError.SyncPassword = 'Bạn cần nhập tên đăng nhập và mật khẩu';
      }
      if (item.SyncPassword && item.SyncPassword.length < 6) {
        formError.SyncPassword = 'Mật khẩu phải lớn hơn hoặc bằng 6 ký tự';
      }
      if (item.SyncPassword != item.SyncRePassword) {
        formError.SyncRePassword = 'Mật khẩu chưa khớp nhau';
      }
    }

    for (var prp in formError) {
      if (prp && formError[prp] != '') {
        formValid = false;
        break;
      }
    }
    this.setState({ formError, formValid });

    if (formValid) {
      item.StoreId = this.state.stores_id;
      this.props.khachhangUpdateRequest(item);
    }
  }
  BackToListkhachhang = (item, e) => {
    this.props.history.push('/khachhang');
  }
  componentDidMount() {
    this.featchConfig();
    this.featchCmb();
    this.featchDetail();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.khachhangEdit.type == khachhangConstant.KHACHHANG_DETAIL_SUCCESS) {
      let { item } = nextProps.khachhangEdit;
      if (item.KhachHangId && item.KhachHangId > 0) {
        var checkedQuanLy = [];
        checkedQuanLy.push(item.IdQuanLy)
        this.setState({
          item: item,
          checkedQuanLy,
          selectedOptionTinhThanh: { value: item.RegionId, label: item.RegionName },
          selectedOptionLich: this.BuildSelectLich(item.TuyenChamSoc, item.TuyenChamSocText),
          idKhEdit: item.KhachHangId
        });
      } else {
        this.setState({
          item: {
            StoreId: this.state.stores_id,
            TrangThai: AppConfig.KHACHHANG_DANGHOATDONG,
            Rank: "",
            SyncUserName: ''
          }
        })
      }
    } else if (nextProps.khachhangEdit.type == khachhangConstant.KHACHHANG_UPDATE_SUCCESS) {
      this.props.history.push("/khachhang");
    } else if (nextProps.khachhangEdit.type == khachhangConstant.KHACHHANG_CMB_LIST_SUCCESS) {
      let { listCmb } = nextProps.khachhangEdit;
      let { item } = this.state;
      this.setState({
        treeQuanLy: listCmb.listQuanLy,
        listDvhc: this.BuildSelectOption(listCmb.listDvhc, "TINHTHANH"),
        listNhomKhachHang: listCmb.listNhomKhachHang,
        item
      });
    } else if (nextProps.khachhangEdit.type == khachhangConstant.KHACHHANG_GET_CONFIG_SUCCESS) {
      let { item } = nextProps.khachhangEdit;
      this.setState({ numberOfUser: item })
    }
  }
  BuildSelectLich(value, text) {
    let opt = []
    if (text != '' && text != null) {
      let arrText = text.split(',');
      let arrValue = (value || '').split(',');
      if (arrValue.length > 0) {
        for (var i in arrValue) {
          opt.push({ label: arrText[i], value: arrValue[i] });
        }
      }
    }
    return opt;
  }
  BuildSelectOption(list, type) {
    var options = [];
    if (list && list.length > 0) {
      if (type == "TINHTHANH") {
        list.map((item) => { options.push({ value: item.TinhThanhId, label: item.Ten, ma: item.Ma }) });
      }
    }
    return options;
  }
  render() {
    const {
      formError,
      item,
      selectedOptionLich,
      selectedOptionTinhThanh,
      listDvhc,
      treeQuanLy,
      idKhEdit,
      listNhomKhachHang,
      activeTab,
      numberOfUser
    } = this.state;

    const {
      khachhangEdit: {
        isRequesting,
        requesting,
        errors,
        messages
      },
    } = this.props
    const khachHangStatusEnum = common.GetKhachHangStatusValue().map(item => {
      const text = common.getKhachHangStatusText(item)
      return { value: item, text: text.result, class: text.class }
    })
    const genLinkViewCustomerInfo = (khachHangId) => {
      if (!khachHangId) {
        return null
      }
      return (
        <a target="_blank" className="btn btn-primary" href={`/#/khachhang247?kh=${khachHangId}`}>Xem thông tin</a>
      )
    }
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={requesting} >
          <div className="mb-2">
            <Nav tabs className="w-100">
              <NavItem>
                <NavLink className={activeTab == 1 ? 'active text-primary' : ''} onClick={() => this.handleTabChange(1)}>
                  Thông tin khách hàng
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink className={activeTab == 2 ? 'active text-primary' : ''} onClick={() => this.handleTabChange(2)}>
                  Liên kết PM Quản lý nhà thuốc
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={activeTab}>
              <TabPane tabId="1" className={activeTab == 1 ? 'active' : ''}>
                <Form className="row">
                  <FormGroup className="col-sm-4">
                    <Label >Mã khách hàng <span className="text-danger">(*)</span></Label>
                    <Input type="text" name="Ma" maxLength="50" placeholder="Mã khách hàng" value={item.Ma || ''} readOnly={idKhEdit > 0 ? true : false} onChange={this.handleControlChange.bind(this)} />
                    <em className="error invalid-feedback">{formError.Ma}</em>
                  </FormGroup>
                  <FormGroup className="col-sm-4">
                    <Label >Tên khách hàng<span className="text-danger">(*)</span></Label>
                    <Input type="text" name="Ten" maxLength="200" placeholder="Tên khách hàng" value={item.Ten || ''} onChange={this.handleControlChange.bind(this)} />
                    <em className="error invalid-feedback">{formError.Ten}</em>
                  </FormGroup>
                  <FormGroup className="col-sm-4">
                    <Label >Địa chỉ <span className="text-danger">(*)</span></Label>
                    <Input type="text" name="DiaChi" maxLength="250" placeholder="Địa chỉ" value={item.DiaChi || ''} onChange={this.handleControlChange.bind(this)} />
                    <em className="error invalid-feedback">{formError.DiaChi}</em>
                  </FormGroup>
                  <FormGroup className="col-sm-4">
                    <Label >Người đại diện<span className="text-danger">(*)</span></Label>
                    <Input type="text" name="NguoiDaiDien" maxLength="50" placeholder="Người đại diện" value={item.NguoiDaiDien || ''} onChange={this.handleControlChange.bind(this)} />
                    <em className="error invalid-feedback">{formError.NguoiDaiDien}</em>
                  </FormGroup>
                  <FormGroup className="col-sm-4">
                    <Label >Di động<span className="text-danger">(*)</span></Label>
                    <Input type="text" name="DienThoai" maxLength="20" placeholder="Di động" value={item.DienThoai || ''} onChange={this.handleControlChange.bind(this)} />
                    <em className="error invalid-feedback">{formError.DienThoai}</em>
                  </FormGroup>
                  <FormGroup className="col-sm-4">
                    <div><Label >Ngày sinh  <span className="text-danger">(*)</span></Label></div>
                    <DatePicker name="NgaySinh" dateFormat="DD/MM/YYYY" selected={this.convertToMoment(item.NgaySinh)} onChange={this.handleDateChange.bind(this, "NgaySinh")} className={"form-control"} />
                    <em className="error invalid-feedback">{formError.NgaySinh}</em>
                  </FormGroup>
                  <FormGroup className="col-sm-4">
                    <Label>Tỉnh/Thành phố<span className="text-danger">(*)</span></Label>
                    <Select
                      name="TinhThanh"
                      placeholder="Chọn tỉnh thành"
                      value={selectedOptionTinhThanh}
                      onChange={this.handleSelectChange}
                      options={listDvhc}
                    />
                    <em className="error invalid-feedback">{formError.RegionId}</em>
                  </FormGroup>
                  <FormGroup className="col-sm-4">
                    <Label>Quản lý<span className="text-danger">(*)</span></Label>
                    <CheckboxTreeList
                      placeholder={`--Chọn quản lý--`}
                      nodes={treeQuanLy}
                      checked={this.state.checkedQuanLy}
                      isMultiChoice={false}
                      onHandleRemove={(item) => this.onHandleRemoveQuanLy(item)}
                      onChoice={e => this.onHandleChoiceQuanLy(e)}
                    />
                    <em className="error invalid-feedback">{formError.IdQuanLy}</em>
                  </FormGroup>
                  <FormGroup className="col-sm-4">
                    <Label>Nhóm khách hàng</Label>
                    <select name="LoaiKhachHangId" className="form-control" value={item.LoaiKhachHangId || -1} onChange={this.handleSelectChange.bind(this, "LoaiKhachHang")}>
                      <option value={-1}>---Chọn nhóm khách hàng---</option>
                      {(listNhomKhachHang && listNhomKhachHang.length &&
                        listNhomKhachHang.map((item, index) => (
                          <option key={index} value={item.Id}>{item.Ten}</option>
                        )))}
                    </select>
                    <em className="error invalid-feedback">{formError.LoaiKhachHangId}</em>
                  </FormGroup>
                  <FormGroup className="col-sm-4">
                    <Label >Mã số thuế</Label>
                    <Input type="text" name="MaSoThue" maxLength="20" placeholder="Mã số thuế" value={item.MaSoThue || ''} onChange={this.handleControlChange.bind(this)} />
                    <em className="error invalid-feedback">{formError.MaSoThue}</em>
                  </FormGroup>
                  <FormGroup className="col-sm-4">
                    <Label >Hợp đồng tham gia</Label>
                    <Input type="text" name="HdThamGia" maxLength="100" placeholder="Hợp đồng tham gia" value={item.HdThamGia || ''} onChange={this.handleControlChange.bind(this)} />
                    <em className="error invalid-feedback">{formError.HdThamGia}</em>
                  </FormGroup>
                  <FormGroup className="col-sm-4">
                    <Label >Điện thoại</Label>
                    <Input type="text" name="Mobile" maxLength="20" placeholder="Điện thoại" value={item.Mobile || ''} onChange={this.handleControlChange.bind(this)} />
                    <em className="error invalid-feedback">{formError.Mobile}</em>
                  </FormGroup>
                  <FormGroup className="col-sm-4">
                    <div><Label >Ngày ký HĐ</Label></div>
                    <DatePicker name="NgayKyHd" dateFormat="DD/MM/YYYY" selected={this.convertToMoment(item.NgayKyHd)} onChange={this.handleDateChange.bind(this, "NgayKyHd")} className={"form-control"} />
                  </FormGroup>
                  <FormGroup className="col-sm-4">
                    <div><Label >Điểm tích luỹ</Label></div>
                    <div className="input-group input-group-md display-table">
                      <div className="input-group-prepend  display-table-cell">
                        <Input type="text" name="DiemTichLuy" disabled={true} maxLength="6" placeholder="0" value={item.DiemTichLuy || ''} />
                      </div>
                      <div className={"display-table-cell"}>
                        <ButtonExt noMb={true}
                          color="primary"
                          iconClass="fa-pencil"
                          displayText="Sửa"
                          btnClick={(e) => this.EditDiemTichLuy()}
                          permission={BtnPermissions.KhachHang.UPDATE_DIEM_TICH_LUY} />
                      </div>
                    </div>
                  </FormGroup>
                  <FormGroup className="col-sm-4">
                    <Label >Lịch chăm sóc</Label>
                    <Select isMulti
                      name="LichChamSoc"
                      value={selectedOptionLich}
                      placeholder="Chọn lịch làm việc"
                      onChange={this.handleSelectChange}
                      options={listLich} />
                    <em className="error invalid-feedback">{formError.DvtId}</em>
                  </FormGroup>
                  <FormGroup className="col-sm-4">
                    <Label >Ngân hàng</Label>
                    <Input type="text" name="NganHang" maxLength="250" placeholder="Ngân hàng" value={item.NganHang || ''} onChange={this.handleControlChange.bind(this)} />
                    <em className="error invalid-feedback">{formError.NganHang}</em>
                  </FormGroup>
                  <FormGroup className="col-sm-4">
                    <Label >Số tài khoản</Label>
                    <Input type="text" name="SoTaiKhoan" maxLength="45" placeholder="Số tài khoản" value={item.SoTaiKhoan || ''} onChange={this.handleControlChange.bind(this)} />
                    <em className="error invalid-feedback">{formError.SoTaiKhoan}</em>
                  </FormGroup>
                  <FormGroup className="col-sm-4">
                    <Label >Chi nhánh</Label>
                    <Input type="text" name="ChiNhanh" maxLength="250" placeholder="Chi nhánh" value={item.ChiNhanh || ''} onChange={this.handleControlChange.bind(this)} />
                    <em className="error invalid-feedback">{formError.ChiNhanh}</em>
                  </FormGroup>
                  <FormGroup className="col-sm-4">
                    <Label>Trạng thái<span className="text-danger">(*)</span></Label>
                    <select name="TrangThai" className="form-control" value={item.TrangThai || -1} onChange={this.handleSelectChange.bind(this, "TrangThai")}>
                      <option value={-1}>---Chọn trạng thái khách hàng---</option>
                      {(khachHangStatusEnum.map((item, index) => (
                        <option key={index} value={item.value}>
                          {item.text}
                        </option>
                      )))}
                    </select>
                    <em className="error invalid-feedback">{formError.TrangThai}</em>
                  </FormGroup>
                  <FormGroup className="col-sm-4">
                    <Label>Xếp hạng</Label>
                    <select name="Rank" className="form-control" value={(item.Rank == undefined || item.Rank == null) ? "" : item.Rank} onChange={this.handleSelectChange.bind(this, "Rank")}>
                      <option value="">---Chọn xếp hạng khách hàng---</option>
                      <option value={0}>Khách hàng tiềm năng</option>
                      <option value={1}>Khách hàng thường xuyên</option>
                      <option value={10}>Khách hàng đặc biệt</option>
                    </select>
                    <em className="error invalid-feedback">{formError.Rank}</em>
                  </FormGroup>
                </Form>
                <div className="clearfix"></div>
              </TabPane>
              <TabPane tabId="2" className={activeTab == 2 ? 'active' : ''}>
                {item.IsIntergrate && item.SyncUserId > 0 && (
                  <Form>
                    <FormGroup className="col-sm-12 mb-0 pt-2">
                      <Label className="text-primary font-weight-bold w-100">
                        Khách hàng đã được liên kết phần mềm quản lý nhà thuốc 247
                      </Label>
                      {genLinkViewCustomerInfo(this.getParam("kid"))}
                    </FormGroup>
                  </Form>
                )}
                {(!item.SyncUserId || item.SyncUserId <= 0) && (
                  <Form>
                    <FormGroup className="col-sm-12">
                      <Label className="text-primary font-weight-bold w-100">
                        Số tài khoản cho phép liên kết còn lại: <em className="font-weight-bold text-danger">{numberOfUser}</em>
                      </Label>
                    </FormGroup>
                    {numberOfUser > 0 && (
                      <Fragment>
                        <FormGroup className="col-sm-12">
                          <Label className="text-primary font-weight-bold w-100">
                            <input
                              onChange={e => this.handleCheckIntergrate(e)}
                              type="checkbox" name="cb_intergrate" className="mr-2"
                              id="cb_intergrate"
                              checked={item.IsIntergrate || false} />Liên kết phần mềm quản lý nhà thuốc
                          </Label>
                        </FormGroup>
                        <FormGroup className="col-sm-4 pull-left">
                          <Label>Tài khoản đăng nhập</Label>
                          <input type="text" name="SyncUserName" maxLength="50"
                            placeholder="Tài khoản đăng nhập"
                            value={item.SyncUserName || ''}
                            autoComplete="off"
                            className={"form-control"}
                            onChange={this.handleControlChange.bind(this)} />
                          <em className="error invalid-feedback">{formError.SyncUserName}</em>
                        </FormGroup>
                        <FormGroup className="col-sm-4 pull-left">
                          <Label >Mật khẩu</Label>
                          <input type="password" name="SyncPassword" maxLength="50" placeholder="Mật khẩu"
                            value={item.SyncPassword || ''}
                            className={"form-control"}
                            autoComplete="off"
                            onChange={this.handleControlChange.bind(this)} />
                          <em className="error invalid-feedback">{formError.SyncPassword}</em>
                        </FormGroup>
                        <FormGroup className="col-sm-4 pull-left">
                          <Label >Nhập lại mật khẩu</Label>
                          <input type="password" name="SyncRePassword" maxLength="50" placeholder="Nhập lại Mật khẩu"
                            value={item.SyncRePassword || ''}
                            autoComplete="off"
                            className={"form-control"}
                            onChange={this.handleControlChange.bind(this)} />
                          <em className="error invalid-feedback">{formError.SyncRePassword}</em>
                        </FormGroup>
                      </Fragment>
                    )}
                  </Form>
                )}
                <div className="clearfix"></div>
              </TabPane>
            </TabContent>
          </div>
          <div className="w-100 mb-2">
            <ButtonExt btnClass="mr-1"
              color="success"
              iconClass="fa-list"
              displayText="Danh sách"
              btnClick={() => this.BackToListkhachhang()}
              permission={""} />
            <ButtonExt btnClass="mr-1"
              color="primary"
              iconClass="fa-save"
              displayText="Lưu"
              btnClick={() => this.Updatekhachhang()}
              permission={BtnPermissions.KhachHang.ADD_OR_UPDATE} />
          </div>
          <DiemTichLuyEdit
            modalEditDiem={this.state.modalEditDiem}
            onClose={this.EditDiemTichLuy}
            onSave={this.props.khachhangUpdateDiemTLRequest}
            Id={item.KhachHangId}
            DiemTichLuy={item.DiemTichLuy}
            Loai={khachhangConstant.LoaiKhachHang.Default}
          />
        </BlockUi>
        <Row>
          <Col md="12">
            {!isRequesting && !!errors.length && (
              <Errors errors={errors} />
            )}
            {!isRequesting && !!messages.length && (
              <Messages messages={messages} />
            )}
          </Col>
        </Row>
      </div>
    )
  }
}
const mapStateToProps = state => ({
  khachhangEdit: state.khachhangEdit,
})
const connected = connect(mapStateToProps, {
  khachhangDetailRequest: khachhangAction.khachhangDetailRequest,
  khachhangUpdateRequest: khachhangAction.khachhangUpdateRequest,
  khachhangListRequest: khachhangAction.khachhangListRequest,
  cmbListRequest: khachhangAction.cmbListRequest,
  khachhangUploadError: khachhangAction.khachhangUploadError,
  khachhangUpdateDiemTLRequest: khachhangAction.khachhangUpdateDiemTLRequest,
  settingGetConfigRequest: settingAction.settingGetConfigRequest
})(KhachhangEdit)

const formed = reduxForm({
  form: 'khachhangEdit',
})(connected)

export default formed;


// WEBPACK FOOTER //
// ./src/views/KhachHang/KhachhangEdit.js